import { render, staticRenderFns } from "./sales-slip-inquiry.vue?vue&type=template&id=1b3c5bc3&scoped=true&"
import script from "./sales-slip-inquiry.vue?vue&type=script&lang=js&"
export * from "./sales-slip-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./sales-slip-inquiry.vue?vue&type=style&index=0&id=1b3c5bc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c5bc3",
  null
  
)

export default component.exports